import { useState } from 'react'
import { db } from '../../services/db'
import type { CompanyType } from '../../utils/types'

export const useCompany = () => {
  const [loadingCreate, setLoadingCreate] = useState(false)

  const registerCompany = async (data: CompanyType) => {
    await db.company.clear()
    setLoadingCreate(true)

    db.company.add(data).finally(() => setLoadingCreate(false))
  }

  const getCompany = async () => {
    const company = await db.company.toArray()

    return company.length ? company[0] : null
  }

  return {
    register: registerCompany,
    isLoading: loadingCreate,
    getData: getCompany,
  }
}
